import { HttpClient } from 'shared/libs/http';
import { ApiResponseDto } from 'shared/types';

export class CandidateAppliedApiService {
   public static addEmployerComment(dto: { id: number; comment: string }) {
      return HttpClient.post<ApiResponseDto<string>>(`/job_apply/${dto.id}/comment`, {
         comment: dto.comment,
      });
   }

   public static deleteEmployerComment(dto: { id: number }) {
      return HttpClient.delete<ApiResponseDto<string>>(`/job_apply/${dto.id}/comment`);
   }
}
